import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { InnerLayout, Pagination } from "../../components"

/* REST API */
import { list, remove } from "../../api/Studio"

/* Helpers */
import { utils } from "../../helpers"

/* Widgets */
import { StudioForm, StudioStream } from "../../widgets/Studio"

/* Sweet alert */
import Swal from "sweetalert2"

/* Translate */
import { t } from "../../translates/translate"




/* Page Studio */
class Studio extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            count: 0,
            page: 1,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load action */
    load = (reload = false, page = 1) => {

        /* Check Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Set Page */
        this.setState({ page })

        /* Send to REST API */
        list(page).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })
    }


    /* Remove Action */
    remove = (data) => {

        Swal.fire({
            title: t("studio.deleteConfirm"),
            text: t("studio.deleteWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f44336",
            reverseButtons: true,
            confirmButtonText: t("studio.deleteButton"),
            cancelButtonText: t("common.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                remove({ id: data.id }).then((response) => {
                    if (response.status === 200) {
                        this.load(true, 1)
                        Swal.fire(utils.notification(t("studio.deletedSuccess"), "success"))
                    }
                    else {
                        Swal.fire(utils.notification(t("swal.generic"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                })
            }
        })
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data, count, page } = this.state

        /* Check Status */
        if (status !== "ok") {
            return (
                <div className="studio--page-table">
                    <InnerLayout inner status={status} reload={() => this.load(true)} />
                </div>
            )
        }

        return (
            <div className="studio--page-table">

                {/* Head */}
                <div className="studio--table-header">
                    <div className="studio--table-column number">#</div>
                    <div className="studio--table-column">{t("studio.name")}</div>
                    <div className="studio--table-column">{t("studio.code")}</div>
                    <div className="studio--table-column">{t("studio.token")}</div>
                    <div className="studio--table-column more"></div>
                </div>

                {/* Body */}
                {data.map((item, index) =>
                    <div className="studio--table-body" key={`${index}`}>
                        <div onClick={() => this._stream.open({ serviceURL: item.serviceURL, recordURL: item.recordURL })} className="studio--table-column number">{(page - 1) * 10 + index + 1}</div>
                        <div onClick={() => this._stream.open({ serviceURL: item.serviceURL, recordURL: item.recordURL })} className="studio--table-column title">{utils.checkValue(item.name, "")}</div>
                        <div onClick={() => this._stream.open({ serviceURL: item.serviceURL, recordURL: item.recordURL })} className="studio--table-column">{utils.checkValue(item.slug, "")}</div>
                        <div onClick={() => this._stream.open({ serviceURL: item.serviceURL, recordURL: item.recordURL })} className="studio--table-column">{(item.uid && item.uid.length > 10) ? item.uid.slice(0, 5) + " ... " + item.uid.slice(-5) : ""}</div>
                        <div className="studio--table-column more">

                            <div className="studio--more-icon">
                                <img src="/images/dots-more.png" alt="More Dot" />
                            </div>

                            <div className="studio--more-menu">

                                <div onClick={() => this._form.open({ type: "edit", ...item })} className="studio--more-menu-item">
                                    <img src="/images/editing.png" alt="Edit" />
                                    <span>{t("studio.edit")}</span>
                                </div>

                                <div className="studio--more-divider" />

                                <div onClick={() => this.remove(item)} className="studio--more-menu-item">
                                    <img src="/images/remove.png" alt="Remove" />
                                    <span className="red">{t("studio.delete")}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                )}

                {/* Pagination */}
                <Pagination size={10} page={page} total={count} onPageChange={(page) => this.load(true, page)} />

            </div>
        )
    }

    /* Draw Header */
    _header = () => {

        /* Fields */
        const { status } = this.state

        return (
            <div className="page-header">

                <h1>{t("studio.title")}</h1>

                {status === "ok" &&
                    <div onClick={() => this._form.open({ type: "create" })} className="button">
                        <img src="/images/plus.png" alt="Plus" />
                        <span>{t("studio.add")}</span>
                    </div>
                }

            </div>
        )
    }

    render = () => (
        <div className="page">

            {/* Draw Header */}
            {this._header()}

            {/* Draw Content */}
            {this._content()}

            {/* Draw Form Modal */}
            <StudioForm ref={(ref) => this._form = ref} reload={() => this.load(true, 1)} />

            {/* Draw Stream Modal */}
            <StudioStream ref={(ref) => this._stream = ref} />

        </div>
    )

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Studio)
